<template>
    <div class="c-member-tier-selector">
        <div v-if="isLoading">
            <!-- Error box -->
            <b-alert show variant="danger text-center mt-4">
                <div v-if="errorMsg">
                    <p>Sorry, something went wrong.</p>
                    <h4 class="alert-heading mt-0">{{ errorMsg }}</h4>
                </div>
                <div v-else>
                    <p>{{ loadingmsg }}</p>
                    <aha-loading-spinner :is-loading="true" class="small" />
                </div>
            </b-alert>
        </div>
        <div v-else>
            <!-- LOADING SPINNNER -->
            <aha-modal
                ref="loadingModal"
                size="md"
                id="loadingModal"
                class="c-loadingModal"
                hide-footer
                hide-header-close
                no-close-on-esc
                no-close-on-backdrop
                centered
                lazy
            >
                <template slot="modal-header">
                    <div class="c-loadingModal__heading">
                        {{ promoModalHeader }}
                    </div>
                </template>
                <aha-loading-spinner :is-loading="true" />
                <p class="text-center">{{ promoModalMessage }}</p>
            </aha-modal>
            <!-- PROMO CODE  - - - - - - - - - - - -->
            <div
                v-if="warningmessage"
                v-html="warningmessage"
                class="w-100 warning"
            ></div>
            <div
                class="promo-code-wrapper d-flex flex-column flex-lg-row justify-content-between"
            >
                <!-- ANCHOR: Title -->
                <!-- TITLE - - - - - - - - - - - - - -->
                <div class="d-flex flex-column">
                    <h1>{{ title }}</h1>
                    <div class="sub-header">
                        {{ componentSubheader }}
                    </div>
                </div>
                <!-- END TITLE - - - - - - - - - - - -->
                <div class="pc-wrapper">
                    <!-- Promo Code Entered -->
                    <div
                        class="c-promo-code c-promo-code__display-wrapper"
                        v-if="promoCode"
                    >
                        <div
                            class="h-color--white c-promo-code__display px-3 w-100"
                        >
                            <span
                                v-if="
                                    isPromoCodeValid === false &&
                                    promoMsgFromApi !== null
                                "
                                >{{ promoMsgFromApi }}</span
                            >
                            <div v-else>
                                Promo applied: <strong>{{ promoCode }}</strong>
                            </div>
                            <span
                                role="button"
                                class="c-promo-code__close"
                                v-on:click="closePromoCodeAppliedDisplay"
                                >&times;</span
                            >
                        </div>
                    </div>
                    <!-- Form Promo Code -->
                    <div class="c-promo-code">
                        <b-button
                            v-b-toggle.collapse-promo-code
                            @keydown="onPromoCodeKeydown($event)"
                            class="c-promo-code__btn btn--select w-100"
                            >{{ promomsg }}</b-button
                        >
                        <b-collapse
                            id="collapse-promo-code"
                            class="c-promo-code__content"
                            v-model="promoVisible"
                        >
                            <!-- Need empty div to fix snapping -->
                            <!-- <div class>&nbsp;</div> -->
                            <form
                                name="form-promo-code"
                                ref="formpromo"
                                action
                                class="form-inline"
                                @submit.prevent="onPromoCodeSubmit"
                                aria-autocomplete="none"
                            >
                                <div class="form-group">
                                    <label for="inputPromoCode" class="sr-only"
                                        >Promo Code</label
                                    >
                                    <input
                                        type="text"
                                        class="form-control input--small"
                                        id="inputPromoCode"
                                        placeholder="Enter promo code"
                                        aria-autocomplete="none"
                                        required
                                    />
                                </div>
                                <button type="submit" class="btn btn-primary">
                                    Add
                                </button>
                            </form>
                        </b-collapse>
                    </div>
                    <!-- t -->
                </div>
            </div>
            <!-- END PROMO CODE - - - - - - - - - - -->
            <!-- TIER SELECTOR - - - - - - - - - -  -->
            <!-- <div class="d-flex d-flex d-flex justify-content-around mb-4 mt-4">
          <p class = "tier-header">Membership Home</p>
          <p class = "tier-header"><b>Membership Tier</b></p>
          <p class = "tier-header">Benefits</p>
          <p class = "tier-header">Who Joines</p>
      </div> -->
            <!-- <div class="row mt-4 mb-4 new-navigation-tier">
        <div v-for="(value, id) in secondarylinks" class="col-xs-12 col-md-3">
            <a :href="value.LinkUrl" :target="value.LinkTarget" class="link-member-icon">{{ value.Text }}</a>
        </div>
    </div> -->
            <hr class="my-4 bg-primary mt-2 mb-2" />
            <div class="row d-block">
                <div class="col-sm">
                    <div class="new-tier-navigation">
                        <div
                            class="row nav nav-pills nav-justified align-items-stretch justify-content-center"
                            id="pills-tab"
                        >
                            <div
                                v-for="(tier, index) in tiers"
                                :key="tier.id"
                                :tierid="tier.id"
                                :class="`${tier.code} flex-even col-md-* com-sm-* col-xs-12`"
                                :tiercode="`${tier.code}`"
                                :style="{
                                    display:
                                        tier.code === 'GM' ? 'none' : 'block',
                                }"
                                @click="handleSelectTier(tier.id)"
                            >
                                <div
                                    class="new-tier-card"
                                    :tiercode="`${tier.code}`"
                                >
                                    <div class="new-tier-img">
                                        <img
                                            :src="tier.imageUrl"
                                            :alt="`${tier.displayName} image`"
                                        />
                                        <div
                                            v-if="tier.code === 'PP'"
                                            class="most-chosen-membership"
                                        >
                                            #1 Most Chosen membership
                                        </div>
                                    </div>
                                    <div class="new-tier-header">
                                        <h2>{{ tier.displayName }}</h2>
                                    </div>
                                    <div class="new-tier-caption">
                                        {{ tier.description }}
                                    </div>
                                    <div
                                        v-if="tier.discountPrice !== null"
                                        class="new-tier-price-tag"
                                    >
                                        <div class="strikethrough d-sm-block">
                                            <span>${{ tier.price }}/yr</span>
                                        </div>
                                        <div
                                            class="new-tier-price-tag-discount-price"
                                        >
                                            <sup>$</sup
                                            >{{ tier.discountPrice }}/<sub
                                                >yr</sub
                                            >
                                        </div>
                                    </div>
                                    <div class="new-tier-price-tag" v-else>
                                        <sup>$</sup>{{ tier.price }}/<span
                                            ><sub>yr</sub></span
                                        >
                                    </div>
                                    <div class="btn-wrapper join-renew">
                                        <a
                                            @click.prevent="onSignUp"
                                            :data-promo-code="`${promoCode}`"
                                            :data-tier-id="`${tier.id}`"
                                            :data-tier-code="`${tier.code}`"
                                            :data-term-remaining="`${tier.termRemaining}`"
                                            :href="`${signupUri.base}?tierId=${
                                                tier.id
                                            }&promoCode=${
                                                isPromoCodeValid
                                                    ? promoCode
                                                    : null
                                            }&earlyCareerTerm=${earlyCareerTerm}&ru=${referrer}&flowType=${flowType}`"
                                            :aria-disabled="orderinprogress"
                                            class="btn btn-primary btn-round btn-block btn--signup mb-4"
                                            :class="{
                                                disabled:
                                                    orderinprogress ||
                                                    disableSignup,
                                            }"
                                            >{{ signUpButtonText }}</a
                                        >
                                    </div>
                                    <div class="new-tier-feature">
                                        <h3>Features & Benefits</h3>
                                        <div
                                            v-html="tier.featuresBenefits"
                                        ></div>
                                    </div>
                                    <p
                                        class="new-tier-additional-benefits col-12"
                                        @keydown.enter="
                                            handleAdditionModalBenefits(
                                                tier.code,
                                                tier.benefitDescription,
                                                tier.name
                                            )
                                        "
                                        @click="
                                            handleAdditionModalBenefits(
                                                tier.code,
                                                tier.benefitDescription,
                                                tier.name
                                            )
                                        "
                                    >
                                        <i tabindex="0"
                                            >+ View Additional Benefits</i
                                        >
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        v-for="tier in tiers"
                        :key="tier.id"
                        :tierid="tier.id"
                        :class="`${tier.code} flex-even`"
                        :tiercode="`${tier.code}`"
                        @click="handleSelectTier(tier.id)"
                    >
                        <div
                            v-if="tier.code === 'GM'"
                            class="footer-member-tier row"
                        >
                            <div class="footer-header">
                                LOOKING FOR A BASIC PROFESSIONAL OPTION WITH
                                LIMITED BENEFITS?
                            </div>
                            <div
                                class="row justify-content-center custom-space"
                            >
                                <div
                                    class="footer-left-content col-xs-12 col-md-* col-sm-*"
                                >
                                    <div class="new-tier-header">
                                        <h2>{{ tier.displayName }}</h2>
                                    </div>
                                    <div class="new-tier-caption">
                                        {{ tier.description }}
                                    </div>
                                    <div class="btn-wrapper join-renew">
                                        <a
                                            @click.prevent="onSignUp"
                                            :data-promo-code="`${promoCode}`"
                                            :data-tier-id="`${tier.id}`"
                                            :data-tier-code="`${tier.code}`"
                                            :data-term-remaining="`${tier.termRemaining}`"
                                            :href="`${
                                                signupUri.base
                                            }?tierId=${3}&promoCode=${
                                                isPromoCodeValid
                                                    ? promoCode
                                                    : null
                                            }&earlyCareerTerm=${earlyCareerTerm}&ru=${referrer}&flowType=${flowType}`"
                                            :aria-disabled="orderinprogress"
                                            class="btn btn-primary btn-round btn-block btn--signup"
                                            :class="{
                                                disabled:
                                                    orderinprogress ||
                                                    disableSignup,
                                            }"
                                            >{{ signUpButtonText }}</a
                                        >
                                    </div>
                                    <div v-if="tier.discountPrice !== null">
                                        <div
                                            class="footer-price-caption d-sm-block strikethrough"
                                        >
                                            Annual fee of General Professional
                                            membership is
                                            <span> ${{ tier.price }}/yr </span
                                            >&nbsp;&nbsp;<b
                                                >${{ tier.discountPrice }}/<sub
                                                    >yr</sub
                                                ></b
                                            >
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div class="footer-price-caption">
                                            Annual fee of General Professional
                                            membership is ${{
                                                tier.price
                                            }}/<span>yr.</span>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="footer-right-content col-xs-12 col-md-6 col-sm-6"
                                >
                                    <div class="new-tier-feature">
                                        <h3>Features & Benefits</h3>
                                        <div
                                            v-html="tier.featuresBenefits"
                                            class="feature-benefits"
                                        ></div>
                                    </div>
                                    <p
                                        class="new-tier-additional-benefits col-12"
                                        @keydown.enter="
                                            handleAdditionModalBenefits(
                                                tier.code,
                                                tier.benefitDescription,
                                                tier.name
                                            )
                                        "
                                        @click="
                                            handleAdditionModalBenefits(
                                                tier.code,
                                                tier.benefitDescription,
                                                tier.name
                                            )
                                        "
                                    >
                                        <i tabindex="0"
                                            >+ View Additional Benefits</i
                                        >
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- END TIER SELECTOR - - - - - - - -  -->
            <!-- MODALS - - - - - - - - - - - - - - - - - - - - -- - - - - - - - - -->
            <!-- Student/Trainee Modal - - - - - - - - - - - - - - - - - - - - - - -->
            <aha-modal
                id="st-membership-modal"
                hide-footer
                centered
                class="st-membership-modal"
                title="Student Trainee Modal"
            >
                <!-- Content Author Heading -->

                <!-- Checkbox -->

                <!-- Content Author Heading -->
                <h2 class="text-center">Student/Trainee</h2>
                <label for="dropdown" class="mb-2 mt-2"
                    >Please provide your graduation year or fellowship
                    completion year, whichever is latest.</label
                >
                <!-- Checkbox -->
                <select
                    v-model="selectedOption"
                    @change="handleDropdownChange"
                    id="dropdown"
                    class="custom-select btn--select"
                >
                    <option
                        v-for="option in dropdownOptions"
                        :key="option.value"
                        :value="option.value"
                    >
                        {{ option.label }}
                    </option>
                </select>

                <span v-if="studentModal" class="field-validation-error"
                    >Please provide your graduation year or fellowship
                    completion year, whichever is latest.</span
                >
                <div class="d-flex justify-content-center mt-4">
                    <button
                        class="btn btn-outline mr-2 w-100 custom-btn-focus"
                        @click="
                            $root.$emit(
                                'bv::hide::modal',
                                'st-membership-modal',
                                $event.target
                            )
                        "
                    >
                        Go Back
                    </button>
                    <a
                        :href="studentModal ? '#' : signupUri.default"
                        class="btn btn-primary w-100 checked-continue custom-btn-focus"
                        @click="studentTraineeDropDown"
                        >Continue</a
                    >
                </div>
            </aha-modal>
            <!-- // End Modal - - - - - - - - - - - - - - - - - - - - - - - - - - - -->
            <!-- Early Career Modal - - - - - - - - - - - - - - - - - - - - - - - - -->
            <aha-modal
                ref="ec-modal"
                id="ec-membership-modal"
                hide-footer
                centered
                class="ec-membership-modal"
                title="Early Career Modal"
            >
                <!-- Content Author Heading -->
                <h2 class="text-center">Early Career</h2>
                <!-- Radio -->

                <fieldset>
                    <legend class="h6">
                        Please indicate number of years since completion of
                        training:
                    </legend>
                    <div
                        v-for="i in 4"
                        :key="i"
                        class="custom-control custom-radio"
                    >
                        <div>
                            <input
                                type="radio"
                                :id="`term${i}`"
                                name="earlyCareerTerm1"
                                class="custom-control-input"
                                :value="i"
                                @change="setEarlyCareerTerm(i)"
                            />
                            <label
                                class="custom-control-label"
                                :for="`term${i}`"
                                >{{ i }}</label
                            >
                            <span
                                v-if="earlyCareerTermValidation"
                                class="field-validation-error"
                                >Please select the early career value</span
                            >
                        </div>
                    </div>
                </fieldset>

                <div class="d-flex justify-content-center mt-4">
                    <button
                        class="btn btn-outline mr-2 w-100 custom-btn-focus"
                        @click="
                            $root.$emit(
                                'bv::hide::modal',
                                'ec-membership-modal',
                                $event.target
                            )
                        "
                    >
                        Go Back
                    </button>
                    <a
                        :href="
                            earlyCareerTermValidation ? '#' : signupUri.default
                        "
                        @click="earlyCarrerTermSelector"
                        class="btn btn-primary w-100 ec-continue custom-active-focus"
                        >Continue</a
                    >
                </div>
            </aha-modal>

            <!-- // End Modal - - - - - - - - - - - - - - - - - - - - - - - - - - - -->

            <!-- Modal for Upgrade - - - - - - - - - - - - - - - - - - - - - - - - -->
            <aha-modal
                id="gp-upgrade-modal"
                hide-footer
                centered
                class="gp-upgrade-modal"
                title="General Professional Upgrade Modal"
            >
                <!-- Content Author Heading -->
                <h2 class="text-center">Did You Know?</h2>
                <!-- Content Author Desc -->
                <p class="">
                    Select Premium Professional and receive even more benefits
                    including 11 free online journals and an additional council.
                </p>
                <!-- Buttons -->
                <div class="d-flex justify-content-center mt-4">
                    <a
                        :href="signupUri.default"
                        class="btn btn-outline mr-2 w-100 custom-btn-focus"
                        >No Thanks</a
                    >
                    <a
                        :href="signupUri.upgrade"
                        class="btn btn-primary w-100 custom-active-focus"
                        >Accept</a
                    >
                </div>
            </aha-modal>
            <!-- END MODALS - - - -- - - - - - - - - - - - - - - - - -- - - -- - -- -  -->
            <!-- Loaded -->
        </div>
        <!-- End v-else isLoading -->
        <aha-modal
            ref="ec-modal"
            id="ecTwo-membership-featureBenfits-modal"
            hide-footer
            centered
            class="ec-membership-modal"
        >
            <!-- <h3 class="mb-3 text-center">{{ headerOfModal }}</h3> -->
            <div v-html="membershipContent"></div>
        </aha-modal>
        <aha-modal
            ref="ec-modal"
            id="ps-membership-featureBenfits-modal"
            hide-footer
            centered
            class="ec-membership-modal"
        >
            <!-- <h3 class="mb-3 text-center">{{ headerOfModal }}</h3> -->
            <div v-html="membershipContent"></div>
        </aha-modal>
        <aha-modal
            ref="ec-modal"
            id="pp-membership-featureBenfits-modal"
            hide-footer
            centered
            class="ec-membership-modal"
        >
            <!-- <h3 class="mb-3 text-center">{{ headerOfModal }}</h3> -->
            <div v-html="membershipContent"></div>
        </aha-modal>
        <aha-modal
            ref="ec-modal"
            id="gm-membership-featureBenfits-modal"
            hide-footer
            centered
            class="ec-membership-modal"
        >
            <!-- <h3 class="mb-3 text-center">{{ headerOfModal }}</h3> -->
            <div v-html="membershipContent"></div>
        </aha-modal>
        <aha-modal
            ref="ec-modal"
            id="st-membership-featureBenfits-modal"
            hide-footer
            centered
            class="ec-membership-modal"
        >
            <!-- <h3 class="mb-3 text-center">{{ headerOfModal }}</h3> -->
            <div v-html="membershipContent"></div>
        </aha-modal>
    </div>
</template>

<script>
import SelectorTab from "@/components/member-tier-selector-tab.vue";
import SelectorPanel from "@/components/member-tier-selector-panel.vue";
import idMixin from "@/mixins/aha-id";
import ahaLoadingSpinner from "./aha-loading-spinner.vue";
import KeyCodes from "@/utils/key-codes";

export default {
    name: "member-tier-selector",
    mixins: [idMixin],
    components: {
        "selector-tab": SelectorTab,
        "selector-panel": SelectorPanel,
        "aha-loading-spinner": ahaLoadingSpinner,
    },
    props: {
        uri: {
            type: String,
            default: "",
        },
        flowType: {
            type: String,
            default: "new",
        },
        promomsg: {
            type: String,
            default: "Have a promo code?",
        },
        promomsg: {
            type: String,
            default: "Have a promo code?",
        },
        promoModalHeader: {
            type: String,
            default: "Processing Request",
        },
        promoModalMessage: {
            type: String,
            default: "Associating promo code to order.",
        },
        promoCodeSession: {
            type: String,
            default: "",
        },
        warningmessage: {
            type: String,
            default: "",
        },
        loadingMessage: {
            type: String,
            default: "Getting Member Levels",
        },
        icons: {
            type: Object,
            default() {
                return {};
            },
        },
        secondarylinks: {
            type: Object,
            default() {
                return {};
            },
        },
        componentTitle: {
            type: String,
            default: "Professional Membership",
        },
        orderinprogress: {
            type: Boolean,
            default: false,
        },
        disableSignup: {
            type: Boolean,
            default: false,
        },
        componentSubheader: {
            type: String,
            default: false,
        },
        stGraduationYear: {
            type: String,
            default: "",
        },
        ecCompletionTerm: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            componentId: null,
            activeItem: "1",
            tierId: null,
            tiercode: "",
            mobile: window.innerWidth <= 700,
            promoCode: null,
            isPromoCodeValid: false,
            tiers: [],
            tiersPromo: [],
            isLoading: true,
            isLoadingPromo: false,
            errorMsg: "",
            promoMsgFromApi: "",
            promoVisible: false,
            earlyCareerTerm: "0",
            termRemaining: null,
            signupUri: {
                base: "/phpapiproxy/signup",
                default: "",
                upgrade: "",
            },
            referrer: "",
            timer: "",
            timerInterval: 10000,
            computedFlowType: this.flowType,
            tabs: [],
            currentTab: 0,
            tabsInitialized: false,
            signUpButtonText: "Join or Renew",
            selectedOption: null,
            dropdownOptions: [],
            studentModal: false,
            membershipContent: "",
            userSelectTierModal: "",
            headerOfModal: "",
            membershipContent: "",
            selectedTier: null,
            earlyCareerTermValidation: false,
        };
    },
    created() {
        // Polyfill for nodelist foreach IE
        if (window.NodeList && !NodeList.prototype.forEach) {
            NodeList.prototype.forEach = Array.prototype.forEach;
        }

        if (this.mobile) {
            this.activeItem = " ";
        }
    },
    computed: {
        title() {
            return this.componentTitle.trim() !== ""
                ? this.componentTitle
                : "Professional Membership";
        },
        loadingmsg() {
            return this.loadingMessage.trim() !== ""
                ? this.loadingMessage
                : "Getting Member Levels";
        },
        filteredTiers() {
            if (this.tiers.length > 0) {
                return this.tiers.slice(0, -1);
            }
        },
    },
    methods: {
        earlyCarrerTermSelector() {
            if (this.earlyCareerTerm !== "0") {
                this.earlyCareerTermValidation = false;
            } else {
                this.earlyCareerTermValidation = true;
            }
        },

        studentTraineeDropDown() {
            if (this.selectedOption !== null) {
                this.studentModal = false;
                
                this.setSignupUriDefault(
                    this.activeItem,
                    this.promoCode,
                    this.earlyCareerTerm,
                    this.referrer,
                    this.computedFlowType,
                    this.selectedOption
                );
            } else {
                this.studentModal = true;
            }
        },

        fetchDropdownOptions() {
            setTimeout(() => {
                const newData = [
                    {
                        value: null,
                        label: "Select Graduation or Fellowship Completion Year",
                    },
                    { value: "2025", label: "2025" },
                    { value: "2026", label: "2026" },
                    { value: "2027", label: "2027" },
                    { value: "2028", label: "2028" },
                    { value: "2029", label: "2029" },
                    { value: "2030", label: "2030" },
                    { value: "2031", label: "2031" },
                    { value: "2032", label: "2032" },
                    { value: "2033", label: "2033" },
                    { value: "2034", label: "2034" },
                    { value: "2035", label: "2035" },
                ];

                // Update the dropdownOptions array
                this.dropdownOptions = newData;

                // Optionally, set a default selected value
                this.selectedOption = newData[0].value;
            }, 500); // Simulating a delay of 1 second (adjust as needed)
        },
        handleDropdownChange() {
            if (this.selectedOption !== null) {
                this.studentModal = false;
            } else {
                this.studentModal = true;
            }
        },
        handleSelectTier(tierId) {
            this.selectedTier = tierId;
            this.activeItem = tierId;
           
        },
        handleAdditionModalBenefits(code, featuresBenefits, name) {
            if (code === "EC") {
                this.$root.$emit(
                    "bv::show::modal",
                    "ecTwo-membership-featureBenfits-modal"
                );
                this.membershipContent = featuresBenefits;
                this.userSelectTierModal = name;
                this.headerOfModal = name;
            } else if (code === "PS") {
                this.$root.$emit(
                    "bv::show::modal",
                    "ps-membership-featureBenfits-modal"
                );
                this.membershipContent = featuresBenefits;
                this.userSelectTierModal = name;
                this.headerOfModal = name;
            } else if (code === "PP") {
                this.$root.$emit(
                    "bv::show::modal",
                    "pp-membership-featureBenfits-modal"
                );
                this.membershipContent = featuresBenefits;
                this.userSelectTierModal = name;
                this.headerOfModal = name;
            } else if (code === "GM") {
                this.$root.$emit(
                    "bv::show::modal",
                    "gm-membership-featureBenfits-modal"
                );
                this.membershipContent = featuresBenefits;
                this.userSelectTierModal = name;
                this.headerOfModal = name;
            } else if (code === "ST") {
                this.$root.$emit(
                    "bv::show::modal",
                    "st-membership-featureBenfits-modal"
                );
                this.membershipContent = featuresBenefits;
                this.userSelectTierModal = name;
                this.headerOfModal = name;
            }
        },

        fetchData(
            uri = "/PhpApiProxy/GetMemberTierAsync",
            flowType = "new",
            promoCode = null
        ) {
            let myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            let raw;

            if (promoCode !== null) {
                raw = JSON.stringify({
                    flowType: flowType,
                    promoCode: promoCode,
                });
                // console.log("RAW BODY: ", raw);
            } else {
                raw = JSON.stringify({
                    flowType: flowType,
                });
            }

            let requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow",
            };

            fetch(uri, requestOptions)
                .then((response) => {
                    if (response.ok) {
                        response.json().then((data) => {
                            this.tiers = data.result.tiers;
                            this.setActive(
                                String(this.tiers[0].id),
                                String(this.tiers[0].code)
                            );
                            this.promoMsgFromApi = data.result.promoCodeMessage;
                            this.isPromoCodeValid = data.result.isPromoValid;
                            this.promoCode = data.result.promoCode;
                            this.isLoading = false;
                            this.cancelTimer(); //clear interval on success
                            if (this.isLoadingPromo === true) {
                                this.isLoadingPromo = false;
                                this.completePromoCodeDataFetch();
                            }

                            // Tabs keyboard accessibility
                            // Initialize tabs - create an array of tabs when data is loaded
                            this.$nextTick(() => {
                                if (this.tabsInitialized === false) {
                                    this.initalizeTabsKeyboarding();
                                    this.tabsInitialized = true;
                                }
                            });
                        });
                    } else {
                        throw Error(
                            response.status + " " + response.statusText
                        );
                    }
                })
                // uncomment for prod
                .catch((error) => {
                    this.errorMsg = error;
                    console.log(error);
                });
            //testing only
            // ANCHOR: LOCAL DATA
            //.catch((error) => this.fetchLocalMembershipData());
        },
        fetchLocalMembershipData() {
            fetch("./data/upgrade.json")
                .then((response) => {
                    if (response.ok) {
                        response.json().then((data) => {
                            this.tiers = data.result.tiers;
                            this.setActive(
                                String(this.tiers[0].id),
                                String(this.tiers[0].code)
                            );
                            this.promoMsgFromApi = data.result.promoCodeMessage;
                            this.isPromoCodeValid = data.result.isPromoValid;
                            this.promoCode = data.result.promoCode;
                            this.isLoading = false;
                            this.cancelTimer(); //clear interval on success
                            if (this.isLoadingPromo === true) {
                                this.isLoadingPromo = false;
                                this.completePromoCodeDataFetch();
                            }

                            // Tabs keyboard accessibility
                            // Initialize tabs - create an array of tabs when data is loaded
                            this.$nextTick(() => {
                                if (this.tabsInitialized === false) {
                                    this.initalizeTabsKeyboarding();
                                    this.tabsInitialized = true;
                                }
                            });
                        });
                    } else {
                        throw Error(response.statusText);
                    }
                })
                .catch((error) => {
                    console.log("Error:", error);
                });
        },
        isActive(tierid) {
            return this.activeItem === tierid;
        },
        setActive(tierid, tiercode) {
            this.activeItem = tierid;
            this.tiercode = tiercode;

            this.tabs.forEach((t, index) => {
                if (t.dataset.tierId == this.activeItem) {
                    this.currentTab = index;
                }
            });
        },
        onHidden() {
            this.activeItem = "";
        },
        onPromoCodeSubmit() {
            // ANCHOR: Promo Submit
            this.$root.$emit("bv::show::modal", "loadingModal");

            this.$root.$emit("bv::toggle::collapse", "collapse-promo-code");
            let promoBtn = document.querySelector(
                ".c-promo-code .c-promo-code__btn"
            );
            let enteredPromoCode =
                document.getElementById("inputPromoCode").value;

            this.fetchData(this.uri, this.computedFlowType, enteredPromoCode);
            this.isLoadingPromo = true;
        },
        completePromoCodeDataFetch() {
            setTimeout(() => {
                this.$root.$emit("bv::hide::modal", "loadingModal");
                this.$refs.formpromo.reset();
                if (this.promoCode !== null) {
                    this.showHidePromoAppliedDisplay("show");
                }
            }, 1500);
        },
        onDataReset() {
            this.$root.$emit("bv::show::modal", "loadingModal");
            this.promoCode = null;
            this.isLoadingPromo = true;
            this.fetchData(this.uri, this.computedFlowType, this.promoCode);
        },
        setEarlyCareerTerm(num) {
            this.earlyCareerTerm = num;
            this.setSignupUriDefault(
                4,
                encodeURIComponent(this.promoCode),
                num,
                this.referrer,
                this.computedFlowType || "new"
            );
        },
        onSignUp(evt) {
            // ANCHOR: Signup
            evt.preventDefault();
            if (this.orderinprogress) return;
            let _code = evt.target.dataset["tierCode"];
            let _tierid = evt.target.dataset["tierId"];
            let _termRemaining = evt.target.dataset["termRemaining"];

            // EC
            if (_termRemaining && _code !== "ST") {
                this.termRemaining = evt.target.dataset["termRemaining"];
            } else {
                this.termRemaining = null;
            }

            // console.log(evt.target.dataset);
            this.setSignupUriDefault(
                _tierid,
                encodeURIComponent(this.promoCode),
                this.earlyCareerTerm,
                this.referrer,
                this.computedFlowType || "new",
                this.selectedOption
            );
            
            if (this.tiers.length === 1) {
                window.location.href = this.signupUri.default;
            } else {
               
                if (_code === "EC") {
                    this.handleEarlyTraining();
                } else if (_code === "GM") {
                    this.$root.$emit("bv::show::modal", "gp-upgrade-modal");
                    this.signupUri.upgrade = `${this.signupUri.base}?tierId=2&promoCode=${this.promoCode}&earlyCareerTerm=${this.earlyCareerTerm}&ru=${this.referrer}&flowType=${this.computedFlowType}`;
                } else if (_code === "ST") {
                    this.handleStudentTrainee();
                } else {
                    //go to new location
                    window.location.href = this.signupUri.default;
                }
            }

            // if (_code === "EC") {
            //   this.earlyCareerTerm = 1;
            // } else {
            //   this.earlyCareerTerm = 0;
            // }
        },

        handleEarlyTraining() {
            if(this.ecCompletionTerm === "") {
                this.$root.$emit("bv::show::modal", "ec-membership-modal");
            } else {
               // this.signupUri.default = `${this.signupUri.base}?tierId=${this.activeItem}&promoCode=${this.promoCode}&earlyCareerTerm=${this.ecCompletionTerm}&ru=${this.referrer}&flowType=${this.computedFlowType}&STGraduationYear=${this.selectedOption}`;
                window.location.href = `${this.signupUri.base}?tierId=${this.activeItem}&promoCode=${this.promoCode}&earlyCareerTerm=${this.ecCompletionTerm}&ru=${this.referrer}&flowType=${this.computedFlowType}&STGraduationYear=${this.selectedOption}`;
            }
        },

        handleStudentTrainee() {
            if (this.stGraduationYear === "") {
                this.$root.$emit("bv::show::modal", "st-membership-modal");
            } else {
                //this.signupUri.default = `${this.signupUri.base}?tierId=${this.activeItem}&promoCode=${this.promoCode}&earlyCareerTerm=${this.earlyCareerTerm}&ru=${this.referrer}&flowType=${this.computedFlowType}&STGraduationYear=${this.stGraduationYear}`;
                window.location.href =`${this.signupUri.base}?tierId=${this.activeItem}&promoCode=${this.promoCode}&earlyCareerTerm=${this.earlyCareerTerm}&ru=${this.referrer}&flowType=${this.computedFlowType}&STGraduationYear=${this.stGraduationYear}`
            }
        },

        setSignupUriDefault(
            _activeItem,
            _promocode,
            _ec,
            _referrer,
            flowType,
            selectOption
        ) {
            this.signupUri.default = `${this.signupUri.base}?tierId=${_activeItem}&promoCode=${_promocode}&earlyCareerTerm=${_ec}&ru=${_referrer}&flowType=${flowType}&STGraduationYear=${selectOption}`;
        },
        getTierIcon(_tiercode) {
            let code = _tiercode;
            let icons = this.icons.membershipicons;
            let icon_path = "";
            if (icons) {
                icons.forEach((icon) => {
                    if (icon.code === code) {
                        icon_path = icon.path;
                    }
                });
            }

            return icon_path;
        },
        getReferrer() {
            function getUrlParameter(name) {
                name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
                var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
                var results = regex.exec(location.search);
                // return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
                return results === null ? "" : results[1];
            }

            this.referrer = getUrlParameter("ru");
            //this.computedFlowType = getUrlParameter('flowType') || this.computedFlowType; //this is changing the flowType prop
            if (getUrlParameter("c")) {
                this.computedFlowType = getUrlParameter("flowType");
            }
            if (this.promoCodeSession === "") {
                this.promoCode = getUrlParameter("promoCode") || null;
            } else {
                this.promoCode = this.promoCodeSession;
            }
        },
        closePromoCodeAppliedDisplay($evt) {
            this.showHidePromoAppliedDisplay("hide");
            if (this.isPromoCodeValid === true) {
                this.onDataReset();
            }
        },
        showHidePromoAppliedDisplay(state) {
            // state = 'show', 'hide'
            let _state = state;
            let _el = document.querySelector(".c-promo-code__display-wrapper");
            let _className = "d-none";

            if (_state === "hide") {
                _el.classList.add(_className);
            } else {
                if (_el.classList.contains(_className)) {
                    _el.classList.remove(_className);
                }
            }
        },
        cancelTimer() {
            clearInterval(this.timer);
        },
        onPromoCodeKeydown(event) {
            // esc to close
            // if (event.keyCode === KeyCodes.ESC || event.key === "Escape") {
            //   this.promoVisible = false;
            // }
            // Down arrow to expand
            if (event.keyCode === KeyCodes.DOWN || event.key === "ArrowDown") {
                event.preventDefault();
                this.promoVisible = true;
            }
        },
        onKeynav(evt) {
            // ANCHOR: Keyboard Nav
            // Tab item keyboarding
            const key = evt.keyCode;
            const shift = evt.shiftKey;

            function stop() {
                evt.preventDefault();
                evt.stopPropagation();
            }

            if (key === KeyCodes.UP || key === KeyCodes.LEFT) {
                stop();
                this.previousTab();
            } else if (key === KeyCodes.DOWN || key === KeyCodes.RIGHT) {
                stop();
                this.nextTab();
            }
        },
        setTab(index) {
            // ANCHOR: SET TAB
            index = index || 0;
            // Prevent setting same tab
            if (index === this.currentTab) {
                return;
            }

            const tab = this.tabs[index];

            // Don't go beyond indexes!
            if (!tab) {
                return;
            }

            // Activate requested current tab, and deactivate any old tabs
            this.tabs.forEach((t) => {
                if (t === tab) {
                    // Set new tab as active
                    this.setActive(tab.dataset.tierId, tab.dataset.tier);
                    setTimeout(() => {
                        tab.focus();
                    }, 0);
                } else {
                    // Ensure non current tabs are not active
                }
            });
            // Update currentTab
            this.currentTab = index;
        },
        previousTab() {
            this.setTab(this.currentTab - 1);
        },
        nextTab() {
            this.setTab(this.currentTab + 1);
        },
        initalizeTabsKeyboarding() {
            // ANCHOR: INITIALIZE TABS FOR KEYBOARDING
            // Initialize when content is loaded
            const tabs = this.$el.querySelectorAll('a[role="tab"]');
            this.tabs = tabs;
        },
    },
    watch: {
        earlyCareerTerm: {
            handler: function (newValue, oldValue) {
                this.earlyCareerTerm = newValue;
                // this.setSignupUriDefault(
                //   this.activeItem,
                //   this.promoCode,
                //   this.earlyCareerTerm,
                //   this.referrer,
                //   this.computedFlowType
                // );
            },
        },
        earlyCareerTerm(newVal, oldVal) {
            this.earlyCareerTerm = newValue;
        },
        selectedTier(newVal, oldVal) {
            this.selectedTier = newVal;
        },
        deep: false,
    },
    mounted() {
        // console.log("prop flow-type: ", this.computedFlowType);
        this.fetchDropdownOptions();
        this.componentId = this.safeId("__PHD_selector_");
        this.getReferrer(); // Get values from the query string
        this.fetchData(
            this.uri,
            this.computedFlowType || "new",
            this.promoCode
        );
        // Call fertchData again after 20 seconds, to solve api being idle
        this.timer = setInterval(() => {
            this.fetchData(
                this.uri,
                this.computedFlowType || "new",
                this.promoCode
            );
        }, this.timerInterval);

        if (this.flowType === "upgrade") {
            this.signUpButtonText = "Upgrade Now";
        }

        // Close promo box on keypress - escape key
        document.addEventListener("keydown", (evt) => {
            if (
                evt.keyCode === KeyCodes.ESCAPE ||
                (evt.key === "Escape" && this.promoVisible === true)
            ) {
                console.log("esc");
                this.promoVisible = false;
            }
        });
    },
    beforeDestroy() {
        clearInterval(this.timer);
    },
};
</script>
<style>
.link-member-icon {
    color: gray;
    font-weight: 500;
    text-decoration: none !important;
}
.footer-price-caption {
    font-size: 12px;
    margin-left: 16px;
    margin-top: 10px;
    margin-left: 2px;
}
.footer-right-content {
    margin-top: 2px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: self-start;
    padding: 0px 12px;
}
.footer-left-content {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
}

.footer-member-tier {
    border-radius: 4px;
    border: 2px solid gray;
    margin-top: 50px;
    margin-left: 2px;
    width: 100%;
}
.footer-header {
    background-color: #636466;
    color: white;
    text-align: center;
    text-transform: uppercase;
    width: 100%;
    font-weight: 500;
}
.new-tier-card {
    border-radius: 2px;
    border: none;
    box-shadow: 5px 10px white;
    width: 274px;
    background-color: white;
    box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.5);
    height: 870px;
    margin: auto;
    position: relative;
}

.newTierCardSelected {
    border-radius: 6px;
    border: none;
    box-shadow: 5px 10px white;
    width: 274px;
    background-color: white;
    box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.5);
    cursor: pointer;
    border: 2px solid #c10e21;
}

/* .new-tier-card:hover {
    border: 2px solid #C10E21;
    border-radius: 6px;
    transform: translateZ(0);
} */

.new-tier-caption:nth-of-type(2) {
    margin-top: 10px;
    width: 200px;
    margin-left: 16px;
}

.new-tier-img {
    width: 274px;
    height: 132px;
    background-color: gray;
    border-radius: 6px;
    position: relative;
    margin-bottom: 20px;
}

.PP .new-tier-img {
    width: 270px;
}

.PP .new-tier-card {
    border: 2px solid #d22338;
    border-radius: 6px 6px 0px 0px;
}

.PP .most-chosen-membership {
    font-size: 10px;
    font-weight: bold;
    width: 274px;
    background-color: #d22338;
    color: #fff;
    border: 2px solid #d22338;
    position: absolute;
    top: -18px;
    border-radius: 6px 6px 0px 0px;
    text-align: center;
    text-transform: uppercase;
    left: -2px;
}

.new-tier-header h2 {
    color: #c10e21;
    text-transform: uppercase;
    text-align: center;
    font-weight: bold;
    margin-top: 60px;
    font-size: 20px;
    padding: 2px;
    line-height: 24px;
}

.PP .new-tier-caption {
    margin-top: 18px;
}

.GM .new-tier-header h2 {
    margin-top: 10px !important;
    color: #c10e21;
    text-transform: uppercase;
    text-align: center;
    font-weight: bold;
    margin-top: 60px;
    font-size: 20px;
    padding: 2px;
    line-height: 24px;
}

.PP .new-tier-header {
    margin-top: 54px;
}

.new-tier-caption {
    font-size: 10px;
    font-weight: bold;
    text-align: center;
    margin: 20px 0px;
    line-height: 16px;
    padding: 0px 22px;
}

.new-tier-price-tag {
    text-align: center;
    font-size: 32px;
    font-weight: bold;
    margin: 20px 0px 25px 0px;
    text-decoration: none !important;
}

.new-tier-price-tag-discount-price {
    text-align: center;
    font-size: 32px;
    font-weight: bold;
    margin: 10px 0px 25px 0px;
}

.new-tier-price-tag span {
    font-size: 22px;
}

.new-tier-feature {
    padding: 0px 8px;
}

.new-tier-feature h3 {
    font-size: 18px;
}

.new-tier-list {
    list-style-type: none;
    font-size: 10px;
    padding: 0px;
}

.new-tier-list li {
    margin-top: 10px;
    color: black;
    text-align: left;
}

.new-tier-additional-benefits {
    font-size: 12px;
    text-align: center;
    font-weight: bold;
    cursor: pointer;
    margin-top: auto;
    position: absolute;
    bottom: 0px;
    text-align: center;
    width: 100%;
    left: 0px;
}

.new-tier-additional-benefits i {
    font-style: normal !important;
    color: #c10e21;
    cursor: pointer;
}

.ST .new-tier-caption {
    margin-top: 44px;
}

.EC .new-tier-caption {
    margin-top: 44px;
}

.selected {
    background-color: #c10e21;
}

.l-tier-selector a {
    color: white !important;
}

.field-validation-error {
    color: #c10e21;
}

.feature-benefits span {
    list-style: 20px;
}

.join-renew {
    width: 170px;
    margin: auto;
}

.join-renew-footer {
    width: 170px;
    margin-left: 16px;
}

.join-renew a:focus {
    border: 2px solid black !important;
}

.GM .new-tier-feature {
    height: 220px;
    padding-top: 30px;
}

.GM .new-tier-feature h3 {
    font-size: 18px;
}

.GM .new-tier-additional-benefits {
    text-align: justify;
}

.flex-even {
    margin-top: 20px;
}

.GM .flex-even {
    padding-top: 10px;
}
.tier-header {
    font-size: 22px;
}

.ST .new-tier-additional-benefits {
    margin-top: 44px;
}
.custom-space {
    width: 100%;
    margin: auto;
}

.new-navigation-tier {
    padding-top: 5%;
    padding-bottom: 5%;
}

#pills-tab {
    margin-top: 30px;
    margin-left: 10px;
}

.flex-even {
    padding-left: 0px !important;
    margin-top: 22px;
}

.bg-primary {
    background-color: gray !important;
}
.sub-header {
    font-size: 14px;
    font-weight: 500;
}
.strikethrough span {
    text-decoration: line-through;
}
.custom-btn-focus:focus {
    background-color: none !important;
    color: black !important;
    border: 2px solid black !important;
}

.custom-active-focus:focus {
    border: 2px solid black !important;
}
#st-membership-featureBenfits-modal .modal-title {
    display: none;
}

#ecTwo-membership-featureBenfits-modal .modal-title {
    display: none;
}

#ps-membership-featureBenfits-modal .modal-title {
    display: none;
}

#pp-membership-featureBenfits-modal .modal-title {
    display: none;
}

#gm-membership-featureBenfits-modal .modal-title {
    display: none;
}

.modal-title {
    display: none;
}
</style>



// WEBPACK FOOTER //
// src/app/components/member-tier-selector.vue